import { HomeIcon, BarChartIcon } from 'lucide-react';
import type { NavigationSectionConfig } from './types';

/**
 * Dashboards Navigation Section
 * Overview and Analytics dashboards
 */
export const dashboardsSections: NavigationSectionConfig[] = [
  {
    id: 'dashboards-section',
    label: 'Dashboards',
    topNavId: 'dashboards',
    items: [
      {
        id: 'dashboard',
        label: 'Overview',
        path: '/dashboard',
        icon: <HomeIcon size={18} />,
        permissions: ['nav:dashboard']
      },
      {
        id: 'analytics-dashboard',
        label: 'Analytics Dashboard (Financial)',
        path: '/insurance/analytics',
        icon: <BarChartIcon size={18} />,
        permissions: ['nav:analytics-dashboard']
      }
    ]
  }
];

